import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiEdit3, FiMonitor, FiImage, FiAward, FiAirplay, FiBarChart2 } = FiIcons;

const Services = () => {
  const services = [
    { icon: FiEdit3, title: 'Editing Naskah & Buku' },
    { icon: FiMonitor, title: 'Layout Jurnal & Buku' },
    { icon: FiImage, title: 'Desain Cover Buku' },
    { icon: FiAward, title: 'Desain Poster Konferensi' },
    { icon: FiAirplay, title: 'Presentasi PowerPoint' },
    { icon: FiBarChart2, title: 'Parafrase & Formatting' }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-primary mb-4">Layanan Kami</h2>
          <p className="text-base md:text-lg text-secondary max-w-2xl mx-auto px-4">
            Solusi teknis menyeluruh untuk mendukung produktivitas penelitian Anda secara profesional.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="flex flex-col sm:flex-row items-center sm:items-start p-6 md:p-8 rounded-2xl border border-divider hover:border-primary/20 hover:shadow-lg transition-all group bg-white text-center sm:text-left"
            >
              <div className="bg-primary/5 p-4 rounded-xl mb-4 sm:mb-0 sm:mr-6 group-hover:bg-primary group-hover:text-white transition-colors shrink-0">
                <SafeIcon icon={service.icon} className="w-7 h-7 md:w-8 md:h-8 text-primary group-hover:text-white" aria-hidden="true" />
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-semibold text-primary mb-2">{service.title}</h3>
                <p className="text-secondary text-sm leading-relaxed">
                  Layanan profesional dengan standar kualitas akademik tertinggi untuk kebutuhan publikasi Anda.
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;